import nodeContentRenderer from './theme/NodeContentRenderer';
import treeNodeRenderer from './theme/TreeNodeRenderer';

export default {
  nodeContentRenderer,
  treeNodeRenderer,
  scaffoldBlockPxWidth: 32,
  rowHeight: 36,
};
